<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
          <b-button v-on:click="goBack" variant="secondary">
              <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
          </b-button>
      </b-col>
    </b-row>
    <div class="addMode">
      <b-row>
        <b-col cols="12">
          <h1 v-if="editMode">Edit User</h1>
          <h1 v-if="addMode">Add User</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>User Details</strong>
            </div>
            <div class="form-container">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userCompany">Company<span class="mandatory">*</span></label>
                    <b-form-select id="site" v-if="companiesLoaded" v-model="newUser.company_id"
                                   :plain="true"
                                   :options="companies"
                                   :disabled="!isMinimumSuperAdmin">
                    </b-form-select>
                    <div v-if="!companiesLoaded">
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="area">Area<span class="mandatory">*</span></label>
                    <b-form-select id="area" v-if="areasLoaded" v-model="newUser.area_id"
                                   :plain="true"
                                   :options="areas"
                                   :disabled="!isMinimumCompanyUser">
                    </b-form-select>
                    <div v-if="!areasLoaded">
                      <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="site">Site<span class="mandatory">*</span></label>
                    <b-form-select id="site" v-if="sitesLoaded" v-model="newUser.site_id"
                                   :plain="true"
                                   :options="sites"
                                   :disabled="!isMinimumAreaUser">
                    </b-form-select>
                    <div v-if="!sitesLoaded">
                      <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userFirstName">First Name<span class="mandatory">*</span></label>
                    <b-form-input v-model="newUser.first_name" type="text" id="userFirstName"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userLastName">Last Name<span class="mandatory">*</span></label>
                    <b-form-input v-model="newUser.last_name" type="text" id="userLastName"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userPassword">Password<span class="mandatory">*</span></label>
                    <b-form-input v-model="newUser.password" type="password" id="userPassword"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userEmail">Email<span class="mandatory">*</span></label>
                    <b-form-input v-model="newUser.email" type="text" id="userEmail"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userGroup">User Permission<span class="mandatory">*</span></label>
                    <b-form-select id="userGroup" v-if="userGroupsLoaded" v-model="newUser.group_id"
                                   :plain="true"
                                   :options="userGroupsForSelect">
                    </b-form-select>
                    <div v-if="!userGroupsLoaded">
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userMobileNo">Mobile Number<span class="mandatory">*</span></label>
                    <b-form-input v-model="newUser.telephone" type="text" id="userMobileNo"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="userIsApproved">Approved</label><br/>
                    <c-switch class="mx-1" id="userIsApproved" name="userIsApproved" color="primary"
                              v-model="newUser.approved" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr/>
              <b-row>
                <b-col cols="12" sm="12" md="12">
                  <p>
                    <b-button v-on:click="saveUser" variant="primary" :disabled="!allowSave">
                      <i class="fa fa-check"></i>&nbsp;Save User
                    </b-button>&nbsp;
                    <b-button :variant="getPasswordResetClass()" @click="confirmPasswordReset">
                        {{isChangingPassword == 1 ? 'Password Change Enabled' : 'Password Change Disabled'}}
                    </b-button>
                    <b-button class="float-right" v-if="editMode && !canUserBeRestored" v-on:click="deleteUser" variant="danger">
                      <i class="fa fa-times"></i>&nbsp;Delete User
                    </b-button>
                    <b-button class="float-right" v-if="editMode && canUserBeRestored" v-on:click="restoreUser" variant="primary">
                      <i class="fa fa-undo"></i>&nbsp;Restore User
                    </b-button>
                  </p>
                  <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong>
                  </b-alert>
                  <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong>
                  </b-alert>
                  <b-alert v-if="saveSuccess" variant="info" show><strong>Data saved successfully.</strong></b-alert>
                  <b-alert v-if="deleteSuccess" variant="info" show><strong>User has been deleted.</strong></b-alert>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner'
  import { Switch as cSwitch } from '@coreui/vue'

  const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'))
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    }
  }

  const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user != null) {
        resolve(user)
      } else {
        reject()
      }
    })
  }

  const getUserGroups = (($http) => {
    return new Promise((resolve, reject) => {
      let headersObj = getHTTPHeaders()
      $http.get('getRolesForSelect', headersObj)
        .then((response) => {
          resolve(response.data.roles)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  })

  const getSiteList = (($http, areaId) => {
    return new Promise((resolve, reject) => {
      let headersObj = getHTTPHeaders()
      $http.get('getSitesForSelect?area_id=' + areaId, headersObj)
        .then((response) => {
          resolve(response.data.sites)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  })

  const getAreaList = (($http, companyId) => {
    return new Promise((resolve, reject) => {
      let headersObj = getHTTPHeaders()
      $http.get('getAreasForSelect?company_id=' + companyId, headersObj)
        .then((response) => {
          resolve(response.data.areas)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  })

  const getCompaniesList = (($http) => {
    return new Promise((resolve, reject) => {
      let headersObj = getHTTPHeaders()
      $http.get('getCompaniesForSelect', headersObj)
        .then((response) => {
          resolve(response.data.companies)
        })
        .catch((err) => {
          console.error(err)
          reject(err)
        })
    })
  })

  export default {
    name: 'user-form',
    props: ['user', 'mode', 'is-deleted'],
    components: {
      LoadingSpinner: LoadingSpinner,
      cSwitch,
    },
    data () {
      return {
        userAuthLevel: '',
        userAuthCode: 0,
        addMode: false,
        editMode: false,
        saveError: false,
        saveInProgress: false,
        deleteSuccess: false,
        saveSuccess: false,
        userObj: {},
        userGroupsLoaded: false,
        companiesLoaded: false,
        sitesLoaded: false,
        areasLoaded: false,
        userItems: [],
        userGroups: [],
        userGroupsForSelect: [],
        companies: [],
        sites: [],
        areas: [],
        show: true,
        // Contact Information
        newUser: this.user,
        isChangingPassword: 0,
        canUserBeRestored: this.isDeleted
      }
    },
    created () {

      this.$data.newUser = this.$props['user'];
      console.log(this.isDeleted);
      this.$data.addMode = true;
      if (this.$props['mode'] === 'edit') {
        this.$data.newUser.approved=(this.$data.newUser.approved ? "1" : "0");
        this.$data.editMode = true;
        this.$data.addMode = false;
        if (this.$data.newUser === null) {
          this.$data.newUser = this.resetUser();
        }
        this.$data.newUser.password = ``;

        // if (this.$data.newUser.groups[0] !== undefined) {
          this.$data.newUser.group_id = this.$data.newUser.roles[0].id;
        // }
      }
      else if (this.$props['mode'] === 'addFromSite') {
        this.$data.addMode = true;
        this.$data.editMode = false;
        if (this.$data.newUser === null) {
          this.$data.newUser = this.resetUser();
        }
      }
      else if (this.$props['mode'] === 'add') {
        this.$data.addMode = true;
        this.$data.editMode = false;
        this.$data.newUser = this.resetUser();
        this.$data.newUser.last_name = '';
      }

      // populate the dropdown controls
      getCurrentUser()
        .then((userDetails) => {
          this.$data.userAuthCode = parseInt(userDetails.authcode);
          this.$data.userAuthLevel = userDetails.auth;
          if (this.$props['mode'] === 'add') {
            this.$data.newUser.company_id = userDetails.company_id;
            this.$data.newUser.area_id = userDetails.area_id;
            this.$data.newUser.site_id = userDetails.site_id;
          }
          return getCompaniesList(this.$http)
        })
        .then((companiesList) => {
          this.$data.companies = companiesList
          this.$data.companiesLoaded = true
          return getAreaList(this.$http, this.$data.newUser.company_id)
        })
        .then((areaList) => {
          this.$data.areas = areaList
          this.$data.areasLoaded = true
          return getSiteList(this.$http, this.$data.newUser.area_id)
        })
        .then((siteList) => {
          this.$data.sites = siteList
          this.$data.sitesLoaded = true
        })
        .then(() => {
          return getUserGroups(this.$http)
        })
        .then((groupList) => {
          this.$data.userGroups = groupList
          // now sort the user groups in to a select list
          this.$data.userGroupsForSelect = this.$data.userGroups.map((element) => {
            return {
              value: element.id,
              text: element.name,
              authcode: element.auth_level
            }
          })
          this.$data.userGroupsForSelect = this.$data.userGroupsForSelect.filter((element) => {
            if (element.text !== 'All Users') {
              if (parseInt(element.authcode) >= this.$data.userAuthCode) {
                return element;
              }
            }
          })
          this.$data.userGroupsLoaded = true;
        })
        .catch((err) => { 
          console.error(err)
        })
    },
    computed: {
      isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
      },
      isMinimumSuperAdmin() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        
        return returnVal;
      },
      isMinimumCompanyUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        return returnVal;
      },
      isMinimumAreaUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
          case 'Area Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        console.log('Area: ', returnVal);
        return returnVal;
      },
      isMinimumSiteUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
          case 'Area Users':
          case 'Site Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        
        return returnVal;
      },
      isUserReadOnly () {
        return this.isReadOnly(this.$data)
      },
      allowSave: function () {

        let allowSaveFlag = true

        if (this.$data.newUser.first_name === '') {
          allowSaveFlag = false
        }
        if (this.$data.newUser.last_name === '') {
          allowSaveFlag = false
        }
        if (this.$data.newUser.password === '' && this.$data.addMode === true) {
          allowSaveFlag = false
        }
        if (this.$data.newUser.email === '') {
          allowSaveFlag = false
        }
        if (this.$data.newUser.company_id === 0) {
          allowSaveFlag = false
        }
        if (this.$data.newUser.telephone === '') {
          allowSaveFlag = false
        }
        if (this.$data.newUser.company_id === 0) {
          allowSaveFlag = false
        }
        if (this.$data.newUser.branch_id === 0) {
          allowSaveFlag = false
        }
        if (this.$data.newUser.site_id === 0) {
          allowSaveFlag = false
        }

        return allowSaveFlag
      }
    },
    watch: {
      'newUser.company_id': function (val, oldVal) {
        // get the branches for the selected company
        getAreaList(this.$http, val)
          .then((areaList) => {
            this.$data.areas = areaList;
            this.$data.areasLoaded = true;
          })
          .catch((err) => {
            console.error(err);
          })
      },
      'newUser.area_id': function (val, oldVal) {
        // get the sites for the selected branch
        getSiteList(this.$http, val)
          .then((sitesList) => {
            this.$data.sites = sitesList;
            this.$data.sitesLoaded = true;
          })
          .catch((err) => {
            console.error(err)
          })
      }
    },
    methods: {
      goBack: function() {
        this.$data.newUser = null;
        this.$parent.closeUserForm();
      },
      isReadOnly (user) {
        return (user.userAuthLevel === 'Read Only');
      },
      resetUser () {
        return {
          first_name: ``,
          last_name: ``,
          password: ``,
          email: ``,
          group_id: 0,
          auth: ``,
          authcode: 0,
          approved: 0,
          telephone: ``,
          company_id: 0,
          area_id: 0,
          site_id: 0,
          pin: 1234,
          groups: []
        }
      },
      confirmPasswordReset() {
        if (this.$data.isChangingPassword == 1) {
          this.$data.isChangingPassword = 0;
        }
        else {
          this.$data.isChangingPassword = 1;
        }
      },
      getPasswordResetClass() {
        return this.$data.isChangingPassword == 1 ? 'warning' : 'outline-primary';
      },
      getHTTPHeaders () {
        let user = JSON.parse(localStorage.getItem('user'))
        return {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization':  'Bearer ' + user.token,
          }
        }
      },
      clearAlerts () {
        this.$data.saveError = false;
        this.$data.saveInProgress = false;
      },
      deleteUser () {
        this.clearAlerts()
        let toBeDeleted = confirm('Are you sure you want to delete this user?')

        if (toBeDeleted) {
          let headersObj = this.getHTTPHeaders()
          this.$http.delete('user/' + this.$data.newUser.id, headersObj)
            .then((response) => {
              this.$data.saveInProgress = false
              this.$data.saveError = false
              if (false === response.data.success) {
                this.$data.saveError = true
              } else {
                this.$data.deleteSuccess = true
                this.goBack();
              }
            })
            .catch((err) => {
              console.error(err)
              this.$data.saveInProgress = false
              this.$data.saveSuccess = false
              this.$data.deleteSuccess = false
              this.$data.saveError = true
            })
        }
      },
      restoreUser() {
        this.clearAlerts()
        const toBeRestored = confirm('Are you sure you want to restore this user?')

        if (toBeRestored) {
          let headersObj = this.getHTTPHeaders()
          this.$http.put('user/restore/' + this.$data.newUser.id, {}, headersObj)
            .then((response) => {
              this.$data.saveInProgress = false
              this.$data.saveError = false
              if (false === response.data.success) {
                this.$data.saveError = true
              } else {
                this.$data.deleteSuccess = true
                this.goBack();
              }
            })
            .catch((err) => {
              console.error(err)
              this.$data.saveInProgress = false
              this.$data.saveSuccess = false
              this.$data.deleteSuccess = false
              this.$data.saveError = true
            })
        }
      },
      saveUser () {
        this.clearAlerts()
        this.$data.saveInProgress = true
        let headersObj = this.getHTTPHeaders()

        // get the group auth string
        // const groupAuthName = this.$data.userGroups.filter((item) => {
        //   return item.id === this.$data.newUser.group_id
        // })[0]

        let userObj = {
          password: this.$data.newUser.password,
          password_confirmation: this.$data.newUser.password,
          email: this.$data.newUser.email,
          first_name: this.$data.newUser.first_name,
          last_name: this.$data.newUser.last_name,
          telephone: this.$data.newUser.telephone,
          company_id: this.$data.newUser.company_id,
          area_id: this.$data.newUser.area_id,
          site_id: this.$data.newUser.site_id,
          // pin: this.$data.newUser.pin_code,
          role_id: this.$data.newUser.group_id,
          approved: this.$data.newUser.approved,
          // auth: groupAuthName.name,
          // authcode: groupAuthName.auth_level
        }

        let URL = 'user';
        if (this.$data.newUser.username !== '' && this.$data.newUser.username !== null && (typeof this.$data.newUser.username !== 'undefined')) {
          userObj.username = this.$data.newUser.username;
          if (this.$data.isChangingPassword == 0) {
            userObj.password = '';
            userObj.password_confirmation = '';
          }
          else {
            userObj.new_password = this.$data.newUser.password;
          }
          userObj.is_active = parseInt(this.$data.newUser.approved);
          URL = 'user/' + this.$data.newUser.id;
          

        } else {
          
          userObj.username = this.$data.newUser.first_name.charAt(0) + this.$data.newUser.last_name;
        }

        // first, save the customer
        let requestVerb='';
        if(this.$props['mode'] === 'add' || this.$props['mode'] === 'addFromSite')
        {
          requestVerb='post';
        }
        else
        {
          requestVerb='put';
        }
        this.$http[requestVerb](URL, userObj, headersObj)
          .then((response) => {
            this.$data.saveInProgress = false;
            this.$data.saveError = false;
            if (false === response.data.success) {
              this.$data.saveError = true;
            } else {
              this.$data.saveSuccess = true;
              this.goBack();
            }
          })
          .catch((err) => {
            console.error(err)
            this.$data.saveInProgress = false;
            this.$data.saveSuccess = false;
            this.$data.saveError = true;
          })
      },
    }
  }
</script>
